import CheckIcon from "./CheckIcon";
import {useEffect, useState} from "react";
import {getRoom} from "../network/network";

type MatchingRoomProps = {
  isFetching: boolean;
  roomId: string | undefined;
  onCancelClick: () => void;
  onBackClick: () => void;
  onRefreshClick: () => void;
}

let latestIntervalId: NodeJS.Timer | undefined = undefined;
let latestTimeout: NodeJS.Timer | undefined = undefined;

const MatchingRoom = ({isFetching, roomId, onCancelClick, onBackClick, onRefreshClick}: MatchingRoomProps) => {
  const [isMatched, setMatched] = useState<boolean>(roomId === undefined);
  const [lock, setLock] = useState<boolean>(roomId === undefined)

  useEffect(() => {
    if (!roomId) {
      setMatched(true);
      startLock();
      return;
    }

    setMatched(false);

    if (latestIntervalId !== null) {
      clearInterval(latestIntervalId);
    }

    const intervalId = setInterval(async () => {
      const response = await getRoom(roomId);

      if (response?.isMatched) {
        setMatched(true);
        startLock();
        clearInterval(intervalId)
      }
    }, 1000);
    latestIntervalId = intervalId;
  }, [roomId]);

  const startLock = () => {
    if (latestTimeout) {
      clearTimeout(latestTimeout);
    }

    setLock(true);

    latestTimeout = setTimeout(() => {
      setLock(false);
    }, 15000);
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      {
        isMatched ? (
          <>
            <div className="bg-green-500 p-4 rounded-full animate-pulse">
              <CheckIcon className="h-12 w-12 text-white"/>
            </div>
            <h1 className="sm:text-4xl font-bold text-white mt-8 text-center">유저를 찾았습니다! 게임을 확인해주세요.</h1>
            <div className="flex gap-8 mt-16">
              <button
                className="font-bold px-8 py-4 text-white bg-gray-500 rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                onClick={onBackClick}
                disabled={isFetching}
              >
                돌아가기
              </button>
              {
                lock ? (
                  <button
                    className="font-bold px-8 py-4 text-white bg-gray-400 rounded-lg hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    15초 뒤 다시 찾기 가능
                  </button>
                ) : (
                  <button
                    className="font-bold px-8 py-4 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    onClick={() => {
                      setMatched(false);
                      onRefreshClick();
                    }}
                    disabled={isFetching}
                  >
                    다시 찾기
                  </button>
                )
              }
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-12 justify-center items-center">
            <h1 className="sm:text-4xl font-bold text-white mt-8 text-center">유저를 찾는 중입니다..</h1>
            <button
              className="font-bold px-8 py-4 text-white bg-gray-500 rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={() => {
                clearInterval(latestIntervalId);
                clearTimeout(latestTimeout);
                onCancelClick();
              }}
            >
              취소하기
            </button>
          </div>
        )
      }
    </div>
  )
};

export default MatchingRoom;